import CommonError from '../Common/CommonError'

const Error400Container = () => {
  return (
    <CommonError color="primary" src="1" />
  )
}

export default Error400Container